import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';
import { Button, TextArea, testClass } from 'omni-common-ui';
import ScrollPageToHereNow from 'components/ScrollPageToHereNow';

const SAVE = 'SAVE';
const DISCARD = 'DISCARD';

class AddInternalNoteControl extends Component {
  constructor(props) {
    super(props);
    this.state = { text: props.text };
  }

  componentWillReceiveProps(props) {
    this.setState({ text: props.text });
  }

  forceSave() {
    if (this._isSaveButtonDisabled()) {
      return;
    }
    return this._onSaveClick();
  }

  _onTextareaValueChanged(text) {
    this.props.onChange && this.props.onChange(text);
    this.setState({ text });
  }

  _onSaveClick() {
    if (is.undefined(this.state.text) || this.state.text.trim() === '') {
      return;
    }
    this.props.onSaveClick &&
      this.props.onSaveClick(this.state.text.trim());
  }

  _isSaveButtonDisabled() {
    return is.undefined(this.state.text) || this.state.text.trim() === '';
  }

  _renderCharacterLimitReadout(maxCharacters) {
    const { text = '' } = this.state;
    if (is.not.string(text)) return null;
    const textLength = text.length;
    return <aside className={styles.AddInternalNoteControl_charactersUsed}>
      {textLength}/{maxCharacters} characters
    </aside>;
  }

  _shouldShowSaveDiscardButtons() {
    return !! this.props.onDiscardClick || this.props.onSaveClick;
  }

  render() {
    const { noteDescription, onDiscardClick, maxCharacters, isMissing } = this.props;

    const classTextArea = classnames(styles.AddInternalNoteControl_textarea, {
      [styles.AddInternalNoteControl_textarea_missing]: isMissing,
    });
    return <div className={classnames(styles.AddInternalNoteControl, testClass('note'))}>
      {! this.props.noAutoScroll && <ScrollPageToHereNow offset={- 350} />}
      <TextArea className={classTextArea}
          onChange={(e) => this._onTextareaValueChanged(e.target.value)}
          maxLength={maxCharacters}
          value={this.state.text}
          {...this.props.textAreaProps} />
      {is.number(maxCharacters) ?
        this._renderCharacterLimitReadout(maxCharacters) : null}
      {is.string(noteDescription) ?
        <p className={styles.AddInternalNoteControl_description}>
          {noteDescription}
        </p> : null }
      {this._shouldShowSaveDiscardButtons() &&
      <Button.Container className={styles.AddInternalNoteControl_buttonWrapper}
          align="right">
        <Button className={classnames(styles.AddInternalNoteControl_buttonWrapper_button, testClass('note-save'))}
            type={Button.Type.primary}
            onClick={() => this._onSaveClick()}
            disabled={this._isSaveButtonDisabled()}>
          {SAVE}
        </Button>
        <Button className={classnames(styles.AddInternalNoteControl_buttonWrapper_button, testClass('note-cancel'))}
            type={Button.Type.default}
            onClick={() => onDiscardClick && onDiscardClick()}>
          {DISCARD}
        </Button>
      </Button.Container>}
    </div>;
  }
}

AddInternalNoteControl.propTypes = {
  text: PropTypes.string,
  maxCharacters: PropTypes.number,
  noteDescription: PropTypes.string,
  onDiscardClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onChange: PropTypes.func,
  textAreaProps: PropTypes.shape(),
  noAutoScroll: PropTypes.bool,
  isMissing: PropTypes.bool,
};

export default AddInternalNoteControl;



// WEBPACK FOOTER //
// ./components/AddInternalNoteControl/index.jsx